export const getPctgColor = (pctg, theme) => {
  if (!Number.isNaN(pctg) && pctg !== undefined && pctg !== null) {
    if (pctg > 0) return theme.palette.colors.up;

    if (pctg === 0) return theme.palette.colors.inert;

    return theme.palette.colors.down;
  }
  return theme.palette.colors.onSecondaryAndDetailBackground;
};
